import { Box, Typography } from "@mui/material";
import { ACCEPTANCE_STATUS, TASK_LIST_TYPE } from "../constants/task.constants";
import EditIcon from "@mui/icons-material/Edit";
import { TimeSince } from "components/DateTime/TimeSince";
import { IconButtonForListWrapper } from "components/Wrappers/EditIcon/IconButtonForListWrapper";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import dayjs from "configs/dayjs.config";

import { dateTimeFormat } from "constants/componentsConstants";
import { SeeMore } from "components/Text/SeeMore";
import { TaskLogs } from "components/Logs/TaskLogs/TaskLogs";
import TaskPreviewModal from "components/Task/TaskPreviewModal";
import DoneIcon from "@mui/icons-material/Done";

export const taskListColumnsL = ({
  currentList,
  handleEdit,
  handleAssignTask,
  openLogModal,
  setOpenLogModal,
  logList,
  setLogList,
}) => [
  {
    accessorKey: "docCode",
    header: "Doc. Details",
    cell: ({ row }) => (
      <TaskPreviewModal
        task={{
          title: row.original.docCode,
          docDetails: row.original.docDetails,
          detail: row.original.taskDetails,
          description: row.original.taskDescription,
          taskByName: row.original.taskByName,
          taskToName: row.original.taskToName,
          taskToOn: row.original.taskToOn,
          acceptanceStatus: row.original.acceptanceStatus,
          acceptanceOn: row.original.acceptanceOn,
          acceptanceComment: row.original.acceptanceComment,
          deadline: row.original.deadline,
          doneStatus: row.original.doneStatus,
          doneOn: row.original.doneOn,
          acknowledgeStatus: row.original.acknowledgeStatus,
          acknowledgeOn: row.original.acknowledgeOn,
        }}
      >
        <FlexBox justifyContent="space-between">
          <Box>{row.original.docCode}</Box>
          {currentList === TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key && (
            <IconButtonForListWrapper onClick={() => handleEdit(row.original)}>
              <EditIcon fontSize="inherit" />
            </IconButtonForListWrapper>
          )}
        </FlexBox>
      </TaskPreviewModal>
    ),
  },
  {
    accessorKey: "docDetails",
    header: "Doc. Details",
    cell: ({ row }) => (
      <FlexBox justifyContent="space-between">
        {row.original.docDetails}
      </FlexBox>
    ),
  },
  {
    accessorKey: "taskDetails",
    header: "Task Details",
    cell: ({ row }) => (
      <FlexBox justifyContent="space-between">
        <SeeMore text={row.original.taskDetails} />
      </FlexBox>
    ),
  },
  {
    accessorKey: "deadline",
    header: "Deadline",
    cell: ({ row }) => (
      <FlexBox justifyContent="space-between">
        <Box>{dayjs(row.original.deadline).format(dateTimeFormat.date)}</Box>
      </FlexBox>
    ),
  },
  {
    accessorKey: "taskByOn",
    header: "Assigned By",
    cell: ({ row }) => (
      <Box>
        <Box>{row.original.taskBy.label}</Box>
        <TimeSince startDate={row.original.taskByOn} />
      </Box>
    ),
  },
  {
    accessorKey: "taskTo",
    header: "Assigned To",
    cell: ({ row }) => (
      <FlexBox justifyContent="space-between">
        <Box>
          <Box>{row.original.taskTo.label}</Box>
          <TimeSince startDate={row.original.taskToOn} />
        </Box>
        <Box>
          {currentList === TASK_LIST_TYPE.CREATED_BY_ME_PENDING.key &&
            row.original.subDocId !== 1 && (
              <IconButtonForListWrapper
                onClick={() => handleAssignTask(row.original)}
              >
                <EditIcon fontSize="inherit" />
              </IconButtonForListWrapper>
            )}
        </Box>
      </FlexBox>
    ),
  },
  {
    accessorKey: "acceptanceStatus",
    header: "Acceptance Status",
    cell: ({ row }) => (
      <>
        <Typography id={row.original.id}>
          {ACCEPTANCE_STATUS[row.original.acceptanceStatus]}
        </Typography>
        <Box>
          <TimeSince startDate={row.original.acceptanceOn} />
        </Box>
        <Box>
          <SeeMore text={row.original.acceptanceComment} />
        </Box>
      </>
    ),
  },
  {
    accessorKey: "doneStatus",
    header: "Completion Status",
    cell: ({ row }) => (
      <FlexBox
        justifyContent="center"
        textAlign="center"
        flexDirection="column"
      >
        <Box>{row.original.doneStatus ? <DoneIcon /> : <></>}</Box>
        <Box>
          {row.original.doneStatus && (
            <TimeSince startDate={row.original.doneOn} />
          )}
        </Box>
      </FlexBox>
    ),
  },
  {
    accessorKey: "acknowledgeStatus",
    header: "Acknowledge Status",
    cell: ({ row }) => (
      <FlexBox
        justifyContent="center"
        textAlign="center"
        flexDirection="column"
      >
        <Box>{row.original.acknowledgeStatus ? <DoneIcon /> : <></>}</Box>
        <Box>
          {row.original.acknowledgeStatus && (
            <TimeSince startDate={row.original.acknowledgeOn} />
          )}
        </Box>
      </FlexBox>
    ),
  },
  {
    accessorKey: "log",
    header: "Log",
    cell: ({ row }) => (
      <TaskLogs
        key={row.original.id}
        id={row.original.id}
        updateCount={row.original.updateCount}
        openLogModal={openLogModal}
        setOpenLogModal={setOpenLogModal}
        logList={logList}
        setLogList={setLogList}
      />
    ),
  },
];
